import { ConsoleLogger } from "@fastoche/ui-core";

export const APP_LOGGER = new ConsoleLogger();
